(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/sport-common/assets/javascripts/sport-constants.js') >= 0) return;  svs.modules.push('/components/sport/sport-common/assets/javascripts/sport-constants.js'); 'use strict';

var HIGHLIGHTED_LEAGUES = [
12692691, 
1000400, 
1000253, 
1000254, 
1000255, 
1000256, 
1000054, 
1000055, 
1000056, 
1000057, 
12732703, 
1000277, 
1000278, 
1000279, 
1000280, 
1000281, 
1000282, 
1000283, 
1000284, 
12692698, 
1000538, 
1000539, 
1000540, 
1000541, 
1000542, 
1000543, 
1000544, 
1000860, 
1000918, 
1000919, 
1000920, 
1000921, 
12692808, 
1003029, 
12692630, 
1000380, 
12691343, 
12692737, 
1000385, 
12692830, 
1000375, 
1000378, 
12692458, 
1000396, 
12692645, 
1000390, 
12692626, 
1000026, 
12692650, 
1000381, 
1000391, 
1000605, 
12692823, 
1000489, 
12690473, 1000482, 
1000626, 
12692967, 
1000626, 
1000402, 
13529298, 
1000483, 
1000479, 
1000599, 
12692204, 
1000951, 
1004310, 
1006140, 
1006195, 
1018740, 
1000567, 
1006126, 
12692900, 
1000710, 
1000212, 
12694340, 
1000239, 
1000957, 
1031563, 
12694340, 
1000805, 
1000022, 
1000023, 
1040765, 
1040804, 
1040993, 
1041087, 
1041405, 
1040764, 
1039163, 
1039232 
];

if (svs.isServer) {
  module.exports = HIGHLIGHTED_LEAGUES;
} else {
  svs.sport = svs.sport || {};
  svs.sport.sport_common = svs.sport.sport_common || {};
  svs.sport.sport_common.constants = svs.sport.sport_common.constants || {};
  svs.sport.sport_common.constants.HIGHLIGHTED_LEAGUES = HIGHLIGHTED_LEAGUES;
}
 })(window);